<div class="filter" [class.clearfix]="enableBarMode" [class.filter-bar]="enableBarMode">
    <div class="search-container clearfix form-inline" [class.bar-mode]="enableBarMode" [class.elastic]="elastic">
        <select class="form-control" [(ngModel)]="classSearch" name="classSearch">
            <option [ngValue]="undefined">{{ "estudiar.streaming.search.todos" | t }}</option>
            <option *ngFor="let clasificacion of clasificaciones | keyvalue" [ngValue]="clasificacion.value['id']">
                {{ clasificacion.value["clasificacion"] }}
            </option>
        </select>

        <input
            type="text"
            name="currentSearch"
            [(ngModel)]="currentSearch"
            class="form-control"
            placeholder="{{ placeholder }}"
            (focusout)="autoclear()"
            (keyup.enter)="search()"
        />
        <cui-button class="btn-search" (click)="search()">
            <fa name="search" class="only-icon"></fa>
        </cui-button>
        <button type="button" class="btn-clear" (click)="clear()" *ngIf="currentSearch && currentSearch.length > 0">
            <fa name="times"></fa>
        </button>
    </div>
</div>
